<template>
  <v-app>
    <app-header
      v-if="
        $store.state.user.isLoggedIn &&
          (!isMobile || $router.currentRoute.name !== 'MeasureGraph')
      "
      :admin="admin"
    ></app-header>
    <router-view :is-mobile="isMobile" :window-height="windowHeight" />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import AppHeader from "@/components/AppHeader";

export default {
  name: "App",
  components: { AppHeader },
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    });
  },
  computed: {
    ...mapGetters("user", { admin: "isAdmin" }),
    isMobile() {
      return this.windowWidth <= 768;
    },
  },
};
</script>
